import { SortDescriptor } from "react-aria-components";

import { VCS_AGENT_POOL_AGENTS_COLUMN_ID } from "./constants";
import { VcsAgentConnectionRow } from "./types";

export const sortVcsAgentConnections = (
  agentConnections: VcsAgentConnectionRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return agentConnections;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...agentConnections].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as VCS_AGENT_POOL_AGENTS_COLUMN_ID) {
      case VCS_AGENT_POOL_AGENTS_COLUMN_ID.AGENT_ID:
        valueA = a.id;
        valueB = b.id;
        break;
      case VCS_AGENT_POOL_AGENTS_COLUMN_ID.METADATA:
      case VCS_AGENT_POOL_AGENTS_COLUMN_ID.DROPDOWN:
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
